/* tslint:disable */
export enum DocumentVisibilityType {
    Label = 1,
    Position = 2,
    DrivingLicense = 4,
}